import { Page } from "../page";

export class QueryMSDCRequest extends Page {
  scanId: string | null;
  createDtStart: Date | null;
  createDtEnd: Date | null;
  sku: String | null;
  plant: String | null;

  constructor() {
    super();
    this.scanId = null;
    this.createDtStart = null;
    this.createDtEnd = null;
    this.sku = null;
    this.plant = null;
  }
}
